import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function GuidesPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("navGuides")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                Comprehensive guides to help you navigate the AllChinaBuy spreadsheet, understand buying processes, and shop with confidence.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group block rounded-2xl bg-background-100 border border-background-200/70 p-6 hover:border-primary-300 hover:shadow-sm transition-all"
                >
                  <span className="inline-block px-2 py-0.5 rounded-md bg-background-200/70 text-foreground-500 text-xs font-medium uppercase tracking-wider mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
                    {t(article.titleKey)}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">
                    {t(article.descKey)}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1 text-primary-600 font-medium">
                      {t("readMore")} <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </Link>
              ))}
              {/* Additional guide cards */}
              {[
                { slug: "beginners-guide", title: "beginnersGuide", desc: "A step-by-step beginner's guide to using AllChinaBuy and the spreadsheet for the first time." },
                { slug: "qc-guide", title: "qcGuide", desc: "Learn how to request, inspect, and understand quality control photos before shipping your items." },
                { slug: "seller-guide", title: "sellerGuide", desc: "How to evaluate sellers, read ratings, and choose reliable vendors on Chinese marketplaces." },
                { slug: "buying-checklist", title: "buyingChecklist", desc: "A comprehensive checklist to follow before every purchase to avoid common mistakes and scams." },
                { slug: "product-verification", title: "productVerification", desc: "Tips for verifying product authenticity, checking reviews, and confirming seller credibility." },
              ].map((guide) => (
                <div
                  key={guide.slug}
                  className="group block rounded-2xl bg-background-100 border border-background-200/70 p-6 hover:border-primary-300 hover:shadow-sm transition-all"
                >
                  <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 text-xs font-medium uppercase tracking-wider mb-3">
                    guide
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
                    {t(guide.title)}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">
                    {guide.desc}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>2026-08-25</span>
                    <span className="flex items-center gap-1 text-primary-600 font-medium">
                      {t("readMore")} <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}